import {view} from '@sail/ui/deprecated';
import {RequestACallConfirmation} from '../components/Forms/RequestACall';

type Props = {
  name: string;
  phoneNumber: string;
  waitTime?: React.ReactNode;
};

export const RequestACallConfirmationScreen = ({
  name,
  phoneNumber,
  waitTime,
}: Props) => {
  return (
    <view.div data-testid="request-a-call-confirmation-screen">
      <RequestACallConfirmation
        name={name}
        phoneNumber={phoneNumber}
        waitTime={waitTime}
      />
    </view.div>
  );
};
